import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { navbarStyles } from './navbarStyles';
import { useTheme } from '@mui/material/styles';
import { Logotype } from '../Logotype/Logotype';
import { ToggleColorMode } from '../ToggleColorMode/ToggleColorMode';
import Avatar from '@mui/material/Avatar';
import { ASSETS_PATH } from '../../services/endpoints';
import { useWallet } from '../../hooks/useWallet';
import { useTranslation } from 'react-i18next';
import { ConnectWalletButton } from '../ConnectWalletButton/ConnectWalletButton';
import { useSelector } from 'react-redux';
import { selectBalance } from '../../store/vestingInfo/vestingInfoSlice';
import { ProfileMenu } from '../ProfileMenu/ProfileMenu';
import { useState } from 'react';
import { OnRamper } from '../OnRamper/OnRamper';
import { ModalBuyTokens } from '../ModalBuyTokens/ModalBuyTokens';

export const HeaderDesktop = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const isDark = theme.palette.mode === 'dark';
  const classes = navbarStyles(theme, isDark);
  const avatarImageBkn = `${ASSETS_PATH}/img/favicon.png`;
  const avatarImageBnb = `${ASSETS_PATH}/img/bnb_logo.png`;
  const { isWalletConnected } = useWallet();
  const balance = useSelector(selectBalance);

  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <>
      <Grid item xs={12} sm={1} lg={1} sx={classes.header}>
        <Paper sx={classes.headerPaperDesktop} elevation={0}>
          <Grid item sx={classes.logoMd}>
            <Box sx={classes.logoContainer}>
              <Link>
                <Logotype {...{ theme, isDashboard: false, isDrawer: false }} />
              </Link>
            </Box>
          </Grid>
        </Paper>
      </Grid>

      <Grid
        item
        container
        md={10}
        sx={classes.headerPaper}
        wrap='nowrap'
        direction='row'
        alignItems='center'
        justifyContent='flex-end'
        columnSpacing={4}
      >
        {!isWalletConnected && (
          <Grid item xs='auto' onClick={handleOpen} sx={classes.onRamperButton}>
            <OnRamper handleClick={handleOpen} />
          </Grid>
        )}
        {isWalletConnected && (
          <>
            <Grid item xs='auto' sx={classes.containerBalanceOnRamper}>
              <Grid
                item
                container
                direction='row'
                columnSpacing={2}
                wrap='nowrap'
              >
                <Grid
                  item
                  container
                  direction='row'
                  wrap='nowrap'
                  sx={{ width: 'auto' }}
                >
                  <Grid item>
                    <Avatar
                      sx={classes.tokenImage}
                      alt='BKN Image'
                      src={avatarImageBkn}
                    />
                  </Grid>
                  <Grid item>
                    <Typography
                      variant='subtitle1'
                      color={theme.palette.text.primary}
                      sx={classes.amount}
                    >
                      {balance?.bknAmount}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography
                      color='secondary'
                      variant='body2'
                      sx={classes.unit}
                    >
                      {t('vesting.amount.unit.bkn')}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  item
                  container
                  direction='row'
                  wrap='nowrap'
                  sx={{ width: 'auto' }}
                >
                  <Grid item>
                    <Avatar
                      sx={classes.tokenImage}
                      alt='BNB Image'
                      src={avatarImageBnb}
                    />
                  </Grid>
                  <Grid item>
                    <Typography
                      color={theme.palette.text.primary}
                      variant='body2'
                      sx={classes.amount}
                    >
                      {balance?.bnbAmount}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography
                      color='secondary'
                      variant='subtitle1'
                      sx={classes.unit}
                    >
                      {t('vesting.amount.unit.wbkn')}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs='auto'
                onClick={handleOpen}
                sx={classes.onRamperButton}
              >
                <OnRamper isCard={true} handleClick={handleOpen} />
              </Grid>
            </Grid>
            <ProfileMenu />
          </>
        )}
        {!isWalletConnected && (
          <Grid item>
            <ConnectWalletButton isNavbar={true} />
          </Grid>
        )}
        <Grid item sx={classes.toggle}>
          <ToggleColorMode />
        </Grid>
      </Grid>
      <ModalBuyTokens open={open} onClose={handleClose} />
    </>
  );
};
